/* ApprovePage — opened from the Approve/Reject buttons in the edit-access
   request email. Sets (or clears) the student's edit access, then shows a
   confirmation. Reached at /approve?id=&t=&do=approve|reject. */
import { useState, useEffect } from "react";
import { getTuapStudent, setEditAccess } from "./tuap";

const GOLD_LO = "#8A6400", INK = "#1A1A1E", TXT = "#5C5C66", LINE = "#E6E6E9", BG = "#F6F6F7";

export default function ApprovePage() {
  const [msg, setMsg] = useState("Working…");
  const [tone, setTone] = useState(INK);

  useEffect(() => {
    (async () => {
      const p = new URLSearchParams(window.location.search);
      const id = p.get("id"), t = p.get("t"), doIt = p.get("do");
      try {
        const s = id ? await getTuapStudent(id) : null;
        if (!s || s.accessToken !== t) {
          setTone("#c0392b"); setMsg("This link isn't valid."); return;
        }
        if (doIt === "approve") {
          await setEditAccess(id, true);
          setTone("#16a34a");
          setMsg(`Edit access approved — ${s.studentName || "the student"} can now edit their portal.`);
        } else if (doIt === "reject") {
          await setEditAccess(id, false);
          setTone(TXT);
          setMsg(`Edit access request from ${s.studentName || "the student"} was rejected.`);
        } else {
          setTone("#c0392b"); setMsg("Unknown action.");
        }
      } catch (e) {
        setTone("#c0392b"); setMsg("Something went wrong. Please try the link again.");
      }
    })();
  }, []);

  return (
    <div style={{ minHeight: "100vh", background: BG, display: "flex", alignItems: "center",
      justifyContent: "center", padding: 24, fontFamily: "'Archivo',-apple-system,sans-serif" }}>
      <style>{`@import url('https://fonts.googleapis.com/css2?family=Archivo:wght@500;700;900&family=Space+Mono:wght@700&display=swap');`}</style>
      <div style={{ maxWidth: 440, width: "100%", background: "#fff", border: `1.5px solid ${LINE}`,
        borderRadius: 14, padding: "36px 32px", textAlign: "center" }}>
        <div style={{ fontFamily: "'Space Mono',monospace", fontSize: 11, fontWeight: 700,
          letterSpacing: ".14em", color: GOLD_LO, textTransform: "uppercase",
          marginBottom: 14 }}>NM Squad · Edit Access</div>
        <div style={{ fontSize: 17, fontWeight: 700, color: tone, lineHeight: 1.5 }}>{msg}</div>
      </div>
    </div>
  );
}
